"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatServerError = void 0;
const formatServerError = (url, status, text) => `Server ${url} error. \nCode: ${status}. \nBody: ${text}`;
exports.formatServerError = formatServerError;
//# sourceMappingURL=command.js.map